// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kyogre: PokeData = {
  "id": 382,
  "name": "kyogre",
  "height": 45,
  "weight": 3520,
  "base_experience": 302,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "body-slam",
    "double-edge",
    "hydro-pump",
    "ice-beam",
    "rest",
    "scary-face",
    "ancient-power",
    "water-spout",
    "sheer-cold",
    "muddy-water",
    "calm-mind",
    "water-pulse",
    "aqua-ring",
    "aqua-tail",
    "origin-pulse"
  ],
  "moves": [
    "body-slam",
    "hydro-pump",
    "scary-face",
    "ancient-power",
    "water-spout",
    "sheer-cold",
    "calm-mind",
    "aqua-tail",
    "aqua-jet",
    "rain-dance",
    "whirlpool",
    "bubble-beam",
    "liquidation"
  ],
  "evolution_chain": {
    "id": 198,
    "item": null,
    "species": [
      {
        "name": "kyogre",
        "order": 412,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 124,
    "speed": 104,
    "ability_power": 173
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
